/**
 * Datetime limit helper
 * A datetime-local input only accepts YYYY-MM-DDTHH:mm. The designer stores a min/max as typed,
 * which is often date-only (e.g. "2026-10-20"); the browser ignores a value in the wrong format,
 * so the limit would silently disappear from the picker.
 */

/**
 * Convert a configured min/max to a datetime-local value.
 * A date-only value becomes the start of that day for min ("T00:00") and the end for max ("T23:59").
 * Returns undefined when no usable limit is set.
 */
export function toDatetimeBound(raw: unknown, edge: 'start' | 'end'): string | undefined {
  if (typeof raw !== 'string') return undefined;
  const value = raw.trim();
  if (!value) return undefined;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return edge === 'start' ? `${value}T00:00` : `${value}T23:59`;
  }
  return value.slice(0, 16);
}
